import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { fetchPageBySlug } from '../lib/cms';

export default function OmOs() {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadData() {
      const data = await fetchPageBySlug('om-os');
      setPageData(data);
      setLoading(false);
    }
    loadData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <i className="fa-solid fa-spinner animate-spin text-4xl text-dahlia-500 mb-4" />
          <p className="text-forest-900 font-medium">Henter indhold...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="pb-20">
      <Helmet>
        <title>{pageData?.meta_titel?.da || pageData?.meta_title?.da || 'Om os | Dahliahjørnet - H.J.K. Multiservice'}</title>
        <meta name="description" content={pageData?.meta_beskrivelse?.da || pageData?.meta_description?.da || 'Her kan du læse mere om os, og hvad vi kan tilbyde.'} />
      </Helmet>
      {/* Header Banner */}
      <div className="relative h-[40vh] min-h-[300px] bg-forest-950 flex items-center justify-center text-center px-6">
        <img
          src={pageData?.banner_billede?.[0] || 'https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=85,format=auto/assets/c347dbd5-ff95-4119-bc58-7c327c410cd6/omos.jpg'}
          alt={pageData?.titel?.da || 'Om os på Dahliahjørnet'}
          className="absolute inset-0 w-full h-full object-cover object-center opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-forest-950 via-forest-950/50 to-transparent" />
        <div className="relative z-10 max-w-4xl">
          <span className="text-white uppercase tracking-[0.25em] font-bold text-xs sm:text-sm mb-3 block">
            {pageData?.underoverskrift?.da || 'Vores historie'}
          </span>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-white leading-tight">
            {pageData?.titel?.da || 'Om os'}
          </h1>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-6 mt-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          {/* Text Content */}
          <div className="lg:col-span-7 flex flex-col gap-8">
            <div className="prose prose-forest max-w-none text-charcoal-700 leading-relaxed flex flex-col gap-6">
              <p className="text-lg font-medium text-forest-950">
                Dahliahjørnet startede i 2019 i rundkørslen ved Vandel mellem Vejle og Billund.
              </p>
              <p>
                Gennem mange år var gården en kartoffelforædlingsgård hvor mange af det sorter vi har i dag er fremavlet.
              </p>
              <p>
                Hans Jørgen overtog gården i 2019 gården og havde ca. 2500 dahliaknolde med. Han havde i flere år haft interesse for denne smukke blomst. Han ønskede at udleve sin drøm om en plukselv mark og det blev så i Vandel.
              </p>
              <p>
                Der er gennem de sidste par år udvidet så der i dag er ca. 6000 knolde i ca. 200 forskellige sorter af denne smukke mexicanske skønhed på dahliahjørnet.
              </p>
              <p>
                Udover knolde laves der også stiklinger af nogle af vores knolde.
              </p>
              <p>
                Dahliahjørnet fik i 2021 sin egen hjemmeside www.dahliahjørnet.dk som altid er et kig værd.
              </p>
              <p>
                For os på dahliahjørnet er imødekommenhed, venlighed og hjælpsomhed egenskaber vi vægter højt.
              </p>
              <p>
                Vores tilgang skal være en god portion professionalisme så alle føler sig velkommen hos os. Enten om man ved meget om dahlia eller om man bare synes en buket kan pynte.
              </p>
              <p>
                Dahliahjørnet er et hyggeligt sted med dyr tæt på. Nysgerrige høns der går frit omkring, katte der leger. Så et godt sted at tage familien med til.
              </p>
            </div>
          </div>

          {/* Sidebar / Info */}
          <div className="lg:col-span-5 flex flex-col gap-8">
            {/* Highlights Box */}
            <div className="bg-white text-charcoal-800 p-8 rounded-3xl shadow-md border border-cream-200">
              <h3 className="text-xl font-serif font-bold text-forest-950 mb-6">Hvad kan du finde hos os?</h3>
              <ul className="flex flex-col gap-4 text-sm text-charcoal-700">
                <li className="flex items-start gap-3">
                  <span className="text-black mt-1.5 flex-shrink-0 text-[8px]">
                    <i className="fa-solid fa-circle" />
                  </span>
                  <span>Stort udvalg af pluk selv dahliablomster</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-black mt-1.5 flex-shrink-0 text-[8px]">
                    <i className="fa-solid fa-circle" />
                  </span>
                  <span>Et utal af farveringe blomster i forskellige størrelse</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-black mt-1.5 flex-shrink-0 text-[8px]">
                    <i className="fa-solid fa-circle" />
                  </span>
                  <span>Køb knolde og stiklinger til din egen have</span>
                </li>
              </ul>
            </div>

            {/* Image Box */}
            <div className="rounded-3xl overflow-hidden shadow-md border border-cream-200 aspect-square">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,height=600,fit=cover,quality=85,format=auto/assets/c347dbd5-ff95-4119-bc58-7c327c410cd6/omos.jpg"
                alt="Gården i Vandel"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
